import React, { useState } from "react";
import "./AddBookmark.css";
import axios from "../../../../axios";
import CreateBookMarkPopup from "./CreateBookMarkPopup";
// import { convertSecondsToMinutes } from "../../../../utils/helper";
import { formatSeconds } from "../../../../utils/helper";
export default function AddBookmark({
  close,
  bookMarkTime,
  userData,
  contentId,
  setComponentRerenderFlag
}) {
  const [bookmarkName, setBookmarkName] = useState("");
  const [errorMsg, setErrorMsg] = useState("")
  const [viewErrorPop, setViewErrorPop] = useState(false)
  const handleBookMarkCreation = async () => {
    let body = {
      user_id: userData.id,
      contentInfo_id: contentId,
      bookmarkName: bookmarkName,
      bookmarkTimeStamp: parseInt(bookMarkTime),
    };
    try {
      let res = await axios.post(
        `/cm/library/book/createUserBookmarksByUserIDAndContentInfoID`,
        body
      );
      if (res.status === 200) {
        // window.location.reload();
        setComponentRerenderFlag((prevFlag) => !prevFlag);
        close();
      }
    } catch (error) {
      if (error) {
        setErrorMsg(error.response.data.message)
        setViewErrorPop(true)
      }
    }
  };
  return (
    <div className="totalContainer_addContent_detail">
      <div className="totalSubContainer_addContent_detail1  p-4">
        <div className="addContent_heading">
          Add Bookmark
          <img
            src="/ContentM_images/Vector.svg"
            alt=""
            onClick={() => {
              close();
            }}
          />
        </div>
        <div className="chapterName col-12 p-0 ">
          <input
            maxLength={50}
            className="input_chapter  p-0"
            placeholder="Add Bookmark Name Here"
            onChange={(e) => {
              setBookmarkName(e.target.value);
            }}
          />
        </div>
        <div className="btnCont">
          <div className='bkmTime'>{formatSeconds(parseInt(bookMarkTime))}</div>
          <button
            className="add_to_libraryBtn_Cm1"
            onClick={() => {
              handleBookMarkCreation();
            }}
          >
            Confirm
          </button>
        </div>
      </div>
      {viewErrorPop && (
        <CreateBookMarkPopup errorMsg={errorMsg} setViewErrorPop={setViewErrorPop} />
      )}
    </div>
  );
}
